// Setup, rules p2-p3: 25 random codenames in a 5x5 grid, one random key.
//
// The key is derived from the seed, exactly like the board - which means it
// technically travels to every client. Spymasters' screens are the only
// place it is RENDERED, the same trust level as every sibling game (the
// whole state is client-readable everywhere on this hub; the audience is
// family, not adversaries).

import { createRngState, shuffle, nextInt } from '../rng/rng';
import { WORDS } from '../words';
import {
  GRID, STARTING_TEAM_AGENTS, OTHER_TEAM_AGENTS, BYSTANDERS, ASSASSINS, TEAMS,
} from '../constants';

/**
 * players: [{ id, name, seat, isBot, team: 'red'|'blue',
 *             role: 'spymaster'|'operative' }]
 * words: the set to deal from (a word-set's list, or a generated custom
 * one) - defaults to the classic list. Needs at least 25.
 */
export function createGameState({ players, seed, words = WORDS }) {
  let rng = createRngState(seed);

  const pool = words.length >= GRID ? words : WORDS;
  let deck;
  [deck, rng] = shuffle(pool, rng);
  const board = deck.slice(0, GRID);

  let startIndex;
  [startIndex, rng] = nextInt(TEAMS.length, rng);
  const startingTeam = TEAMS[startIndex];
  const otherTeam = TEAMS[1 - startIndex];

  const identities = [
    ...Array(STARTING_TEAM_AGENTS).fill(startingTeam),
    ...Array(OTHER_TEAM_AGENTS).fill(otherTeam),
    ...Array(BYSTANDERS).fill('bystander'),
    ...Array(ASSASSINS).fill('assassin'),
  ];
  let key;
  [key, rng] = shuffle(identities, rng);

  return {
    seed,
    players: players.map((p, i) => ({ ...p, seat: i })),
    board,
    key,
    revealed: board.map(() => false),
    startingTeam,
    turn: {
      team: startingTeam, // "The starting team will give the first clue" (p3)
      phase: 'clue', // 'clue' | 'guess'
      clue: null, // { word, count } - count is a number or 'unlimited'
      guessesLeft: 0, // meaningless until a clue lands; null = unlimited
      guessedThisTurn: 0,
    },
    // One line per event, for the sidebar - what a table would remember.
    log: [],
    meta: {
      phase: 'playing', // 'playing' | 'finished'
      winner: null,
      // How the game ended: 'agents' (all found) or 'assassin'.
      endedBy: null,
      seq: 0,
    },
  };
}
